import React from "react";
import { useAuth } from "../../contexts/auth/auth.context";
import AuthViews from "./authViews";
import { Box, Dialog, useMediaQuery } from "@mui/material";
import { styled } from "@mui/material/styles";
import useModal from "../../hooks/useModal";
import ConfirmationModal from "../../components/confirmationModal/confirmationModal";
import { useTranslation } from "react-i18next";
import ModalContainer from "../modal/modal";

function AuthModal() {
  const { t } = useTranslation();
  const { authModalOpen, closeAuthModal, isConfirmNeedForCloseModal } =
    useAuth();

  const isMobile = useMediaQuery("(max-width:599px)");

  const [isOpenConfirm, openConfirm, closeConfirm] = useModal();

  return (
    <>
      <ModalContainer
        fullScreen={isMobile}
        closable={isMobile}
        open={authModalOpen}
        onClose={() => {
          if (isConfirmNeedForCloseModal.current) {
            openConfirm();
            return;
          }
          closeAuthModal();
        }}
      >
        <Box sx={{ padding: "2rem", margin: "auto 0", width: { sm: "350px" } }}>
          <AuthViews />
        </Box>
      </ModalContainer>
      <ConfirmationModal
        open={isOpenConfirm}
        handleClose={closeConfirm}
        title={t("sure.to.end.auth")}
        onSubmit={() => {
          closeAuthModal();
          closeConfirm();
        }}
      />
    </>
  );
}

export default AuthModal;
